import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-sign-up-consent flex col" }
const _hoisted_2 = { class: "black regular" }
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "b-sign-up-consent__checkbox-title" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "fs-general black regular" }

import { computed, ref, WritableComputedRef } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { User } from '@/types';
import ButtonComponent from '@/views/components/ButtonComponent.vue';
import SpinnerComponent from '@/views/components/SpinnerComponent.vue';
import CustomCheckboxComponent from '../CustomCheckboxComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Consent',
  props: {
  onAccept: {
    type: Function,
  },
},
  setup(__props) {

const props = __props



const { t } = useI18n();
const store = useStore();

const form = ref<User.SignUpConsentForm>(new User.SignUpConsentForm());

const privacyPolicyLinkByLocale = computed(
  () => store.getters['support/privacyPolicyLinkByLocale']
);
const termsLinkByLocale = computed(
  () => store.getters['support/termsLinkByLocale']
);

const isAllChecked: WritableComputedRef<boolean> = computed({
  get() {
    return (
      form.value.isAdult.value &&
      form.value.isAcceptTransferPersonalData.value &&
      form.value.isAcceptSharingPersonalData.value
    );
  },
  set(value) {
    form.value.isAdult.value = value;
    form.value.isAcceptTransferPersonalData.value = value;
    form.value.isAcceptSharingPersonalData.value = value;
  },
});

function handleSubmit() {
  if (!form.value.isValid() || !props.onAccept) {
    return;
  }

  form.value.isLoading = true;
  props.onAccept();
}

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('authModal.register.consent.title')), 1),
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_unref(t)('authModal.register.consent.subtitle')), 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["b-sign-up-consent__checkboxes flex col", { disabled: form.value.isLoading }])
    }, [
      _createVNode(CustomCheckboxComponent, {
        modelValue: _unref(isAllChecked),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isAllChecked) ? (isAllChecked).value = $event : null)),
        id: "all"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('authModal.register.consent.checks.all')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(CustomCheckboxComponent, {
        modelValue: form.value.isAdult.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.isAdult.value) = $event)),
        id: "is-adult",
        requiredError: 
          form.value.isAdult.isValidationEnabled && !form.value.isAdult.isValid()
        ,
        onOnChange: _cache[2] || (_cache[2] = ($event: any) => (form.value.isAdult.isValidationEnabled = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_i18n_t, {
            keypath: "authModal.register.consent.checks.adult",
            tag: "p",
            class: "b-sign-up-consent__checkbox-title",
            scope: "global"
          }, {
            terms: _withCtx(() => [
              _createElementVNode("a", {
                href: _unref(termsLinkByLocale),
                target: "_blank",
                class: "black",
                rel: "noopener"
              }, _toDisplayString(_unref(t)('terms')), 9, _hoisted_6)
            ]),
            privacy: _withCtx(() => [
              _createElementVNode("a", {
                href: _unref(privacyPolicyLinkByLocale),
                target: "_blank",
                class: "black",
                rel: "noopener"
              }, _toDisplayString(_unref(t)('privacy')), 9, _hoisted_7)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "requiredError"]),
      _createVNode(CustomCheckboxComponent, {
        modelValue: form.value.isAcceptTransferPersonalData.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.isAcceptTransferPersonalData.value) = $event)),
        id: "is-accept-transfer-personal-data",
        requiredError: 
          form.value.isAcceptTransferPersonalData.isValidationEnabled &&
          !form.value.isAcceptTransferPersonalData.isValid()
        ,
        onOnChange: _cache[4] || (_cache[4] = ($event: any) => (
          form.value.isAcceptTransferPersonalData.isValidationEnabled = false
        ))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_i18n_t, {
            keypath: "authModal.register.consent.checks.transferPersonalData",
            tag: "p",
            class: "b-sign-up-consent__checkbox-title",
            scope: "global"
          }, {
            privacy: _withCtx(() => [
              _createElementVNode("a", {
                href: _unref(privacyPolicyLinkByLocale),
                target: "_blank",
                class: "black",
                rel: "noopener"
              }, _toDisplayString(_unref(t)('privacy')), 9, _hoisted_8)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "requiredError"]),
      _createVNode(CustomCheckboxComponent, {
        modelValue: form.value.isAcceptSharingPersonalData.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.isAcceptSharingPersonalData.value) = $event)),
        id: "is-accept-sharing-personal-data",
        requiredError: 
          form.value.isAcceptSharingPersonalData.isValidationEnabled &&
          !form.value.isAcceptSharingPersonalData.isValid()
        ,
        onOnChange: _cache[6] || (_cache[6] = ($event: any) => (form.value.isAcceptSharingPersonalData.isValidationEnabled = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_i18n_t, {
            keypath: "authModal.register.consent.checks.sharingPersonalData",
            tag: "p",
            class: "b-sign-up-consent__checkbox-title",
            scope: "global"
          }, {
            privacy: _withCtx(() => [
              _createElementVNode("a", {
                href: _unref(privacyPolicyLinkByLocale),
                target: "_blank",
                class: "black",
                rel: "noopener"
              }, _toDisplayString(_unref(t)('privacy')), 9, _hoisted_9)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "requiredError"])
    ], 2),
    _createVNode(ButtonComponent, {
      class: "yellow no-shadow no-text-transform",
      onClick: handleSubmit
    }, {
      default: _withCtx(() => [
        (form.value.isLoading)
          ? (_openBlock(), _createBlock(SpinnerComponent, {
              key: 0,
              color: "black"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_unref(t)('authModal.register.consent.btn')), 1)
            ], 64))
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('authModal.register.consent.disagree')), 1)
  ]))
}
}

})